var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideoVerificationIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  rx: 7,
  fill: "#5F1341"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.8301 8H23C24.1 8 25 8.9 25 10V22C25 23.1 24.1 24 23 24H7C5.9 24 5 23.1 5 22V10C5 8.9 5.9 8 7 8H10.1699L12 6H18L19.8301 8ZM11.0498 10H7V22H23V10H18.9502L17.1201 8H12.8799L11.0498 10ZM15 11C17.76 11 20 13.24 20 16C20 18.76 17.76 21 15 21C12.24 21 10 18.76 10 16C10 13.24 12.24 11 15 11ZM15 13C13.35 13 12 14.35 12 16C12 17.65 13.35 19 15 19C16.65 19 18 17.65 18 16C18 14.35 16.65 13 15 13Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideoVerificationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video-verification-icon.bbc00ebb8101e63a9772960eccfb038c.svg";